/**
 * The shared "rounded to the clinical grid" disclosure caption for the
 * mutating proposal cards (symmetric margin, ring, asymmetric margin). Each
 * card builds its own message — single value, inner/outer pair, or labelled
 * directions — but the visual treatment (warning colour + icon) is identical
 * and lives here so it cannot drift between ops.
 */
import { Typography } from '@mui/material';
import { AlertTriangle } from 'lucide-react';

export interface GridRoundingNoteProps {
    readonly children: React.ReactNode;
}

export default function GridRoundingNote({ children }: GridRoundingNoteProps) {
    return (
        <Typography
            variant="caption"
            color="warning.main"
            sx={{ display: 'flex', alignItems: 'center' }}
        >
            <AlertTriangle
                size={12}
                style={{ marginRight: 4, flexShrink: 0 }}
            />
            {children}
        </Typography>
    );
}
